import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { cn } from '@/lib/utils';
import * as icons from 'lucide-vue-next';
import { computed } from 'vue';

interface Props {
    name: string;
    class?: string;
    size?: number | string;
    color?: string;
    strokeWidth?: number | string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Icon',
  props: {
    name: {},
    class: { default: '' },
    size: { default: 16 },
    color: {},
    strokeWidth: { default: 2 }
  },
  setup(__props: any) {

const props = __props;

const className = computed(() => cn('h-4 w-4', props.class));

const icon = computed(() => {
    const iconName = props.name.charAt(0).toUpperCase() + props.name.slice(1);
    return (icons as Record<string, any>)[iconName];
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(icon.value), {
    class: _normalizeClass(className.value),
    size: _ctx.size,
    "stroke-width": _ctx.strokeWidth,
    color: _ctx.color
  }, null, 8, ["class", "size", "stroke-width", "color"]))
}
}

})